export var EstadoCivilEnum;
(function (EstadoCivilEnum) {
    EstadoCivilEnum["SOLTEIRO"] = "SOLTEIRO";
    EstadoCivilEnum["DIVORCIADO"] = "DIVORCIADO";
    EstadoCivilEnum["VIUVO"] = "VIUVO";
    EstadoCivilEnum["CASADO"] = "CASADO";
    EstadoCivilEnum["CASADO_COMUNHAO_PARCIAL"] = "CASADO_COMUNHAO_PARCIAL";
    EstadoCivilEnum["CASADO_COMUNHAO_UNIVERSAL"] = "CASADO_COMUNHAO_UNIVERSAL";
    EstadoCivilEnum["CASADO_SEPARACAO_TOTAL"] = "CASADO_SEPARACAO_TOTAL";
    EstadoCivilEnum["UNIAO_ESTAVEL"] = "UNIAO_ESTAVEL";
})(EstadoCivilEnum || (EstadoCivilEnum = {}));
(function (EstadoCivilEnum) {
    var mapDescricao = new Map([
        [EstadoCivilEnum.SOLTEIRO, "Solteiro"],
        [EstadoCivilEnum.DIVORCIADO, "Divorciado"],
        [EstadoCivilEnum.VIUVO, "Viúvo"],
        // [EstadoCivilEnum.CASADO, "Casado"],
        [EstadoCivilEnum.CASADO_COMUNHAO_PARCIAL, "Casado em regime de comunhão parcial de bens"],
        [EstadoCivilEnum.CASADO_COMUNHAO_UNIVERSAL, "Casado em regime de comunhão universal de bens"],
        [EstadoCivilEnum.CASADO_SEPARACAO_TOTAL, "Casado em regime de separação total de bens"],
        [EstadoCivilEnum.UNIAO_ESTAVEL, "Convivente em União estável"],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    EstadoCivilEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    EstadoCivilEnum.getOptions = getOptions;
})(EstadoCivilEnum || (EstadoCivilEnum = {}));
